import AdditionalDndPanel from './AdditionalDndPanel';

export default AdditionalDndPanel;
